<template>
  <div class="news_page">
    <DashHeader />
    <Gauges />
    <p>
      <router-link to="/">BACK</router-link>
    </p>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
import Gauges from "@/components/Gauges.vue";
export default {
  name: "GaugesView",
  components: {
    DashHeader,
    Gauges
  }
};
</script>
